import { deleteCookie as _deleteCookie, setCookie as _setCookie, getCookie as _getCookie } from '@beef/utils';
export { _getCookie as getCookie };
export function setCookie(_ref) {
  var name = _ref.name,
    value = _ref.value,
    domain = _ref.domain,
    ttl = _ref.ttl,
    path = _ref.path;
  _setCookie({
    name: name,
    value: value,
    domain: domain,
    ttl: ttl,
    path: path ? '/' : ''
  });
}
export function deleteCookie(name, path) {
  _deleteCookie(name, {
    path: path
  });
}
export var cookiesDeviceService = {
  getCookie: function getCookie(name) {
    var cookie = [];
    try {
      cookie = JSON.parse(_getCookie(name)) || [];
    } catch (e) {
      // no action on error
    }
    return cookie;
  },
  addDevice: function addDevice(type, deviceId) {
    var deviceList = [];
    try {
      deviceList = JSON.parse(_getCookie(type)) || [];
    } catch (e) {
      // no action on error
    }
    if (!deviceList.includes(deviceId)) {
      deviceList.push(deviceId);
    }
    setCookie({
      name: type,
      value: JSON.stringify(deviceList),
      path: true
    });
    return deviceList;
  },
  deleteDevice: function deleteDevice(type, deviceId) {
    var deviceList = [];
    try {
      deviceList = JSON.parse(_getCookie(type)) || [];
    } catch (e) {
      // no action on error
    }
    var newList = deviceList.filter(function (item) {
      return item !== deviceId;
    });
    setCookie({
      name: type,
      value: JSON.stringify(newList),
      path: true
    });
    return newList;
  }
};
export var getRootCookieDomain = function getRootCookieDomain() {
  if (/beelinetst/.test(window.location.hostname)) {
    return '.beelinetst.ru';
  }
  if (/vimpelcom/.test(window.location.hostname)) {
    return '.vimpelcom.ru';
  }
  if (/localhost/.test(window.location.hostname)) {
    return '';
  }
  return '.beeline.ru';
};